'use client';
import { Props as ChangeCustomerPasswordProps } from './change-customer-password.component';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import dynamic from 'next/dynamic';

const DynamicChangeCustomerPasswordComponent: ComponentType<ChangeCustomerPasswordProps> = dynamic(
  () => import('./change-customer-password.component')
);

export default DynamicChangeCustomerPasswordComponent;

export function calculateChangeCustomerPasswordPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 500 },
    { sinceWidth: 425, height: 450 },
    { sinceWidth: 525, height: 430 },
    { sinceWidth: 625, height: 400 },
    { sinceWidth: 768, height: 800 },
    { sinceWidth: 1024, height: 780 },
    { sinceWidth: 1442, height: 600 }
  ];

  return {
    heightSinceWidth
  };
}
